const timeSeries = {
  queryState: {
    projectMetaLoadFailed: "Failed to load map information",
    mappingImageListLoadFailed: "Failed to load images",
    mappingImageListNotLoaded: "Images have not been loaded yet",
    issueListLoadFailed: "Failed to load the issue list",
    projectNotSelected: "No project has been specified to load",
  },
  clip: {
    title: "Clipping Tool",
    count: "{{count}} total",
    addClipping: "Add Clipping",
    clippingList: "Clipping List",
    box: "Box",
    plane: "Plane",
    boxName: "Box {{index}}",
    planeName: "Plane {{index}}",
    addBySurfaceClick: "Add by clicking surface",
    placingHint: "Click a model surface in the 3D view",
    placingCancel: "Right-click or ESC to cancel",
    limitNotice: "Up to {{max}} clippings can be active at once",
    emptyList: "No clippings yet.",
    emptyListDesc: "Add one above.",
    toggleItem: "Toggle clipping",
    toggleItemNamed: "Show {{name}}",
    itemGroupNamed: "{{name}} settings",
    deleteNamed: "Delete {{name}}",
    deleteTitle: "Delete Clipping",
    deleteConfirm: "Delete clipping '{{name}}'?",
    deleteIrreversible: "Deleted clippings cannot be restored.",
    deleteCancel: "Cancel",
    deleteConfirmAction: "Delete",
    sizeLabel: "Side",
    namePlaceholder: "Section name",
    nameInputLabel: "Name",
    renameNamed: "Rename {{name}}",
    renameTitle: "Rename section",
    renameConfirm: "Save",
    renameCancel: "Cancel",
    delete: "Delete",
    disabledTitle: "Clipping off",
    disabledDesc: "Turn on to use",
    editMode: "Edit",
    editTooltipMain: "Drag corners and faces to reshape",
    editTooltipSub: "Turn off to move the camera",
    wireframe: "Edges",
    capFill: "Cap Fill",
    invert: "Invert",
    save: "Save",
    unsavedChanges: "Unsaved changes",
    loading: "Loading clippings…",
    loadFailed: "Failed to load clippings",
    retry: "Retry",
    saveFailed: "Failed to save. Please try again.",
    horizontal: "Horizontal",
    vertical: "Vertical",
    gap: "Gap",
    area: "Area",
    rotation: "Rotation",
    tilt: "Tilt",
    reset: "Reset",
    undo: "Undo",
    redo: "Redo",
  },
  page: {
    title: "Time Series Inspection",
  },
  sidebar: {
    layers: "Layers",
    projectInfo: "Project Information",
    issues: "Issues",
    report: "Report",
  },
  modal: {
    issueInfo: "Issue Information",
    crossSection: "Cross Section",
  },
  map: {
    satelliteMap: "Satellite Map",
    viewerCount: "Viewer Count",
    imageList: "Image List",
    favoriteOnly: "Show Favorites Only",
    standard: "Base",
    noImages: "No images to display",
    nearbyImagesOnly: "Photos within 100m are displayed",
  },
  drawingTools: {
    draw: "Draw",
    edit: "Edit",
    etc: "Etc",
  },
  toolbar3d: {
    create: "Draw",
    measurement: "Calc",
    howToUse: "How to Use",
    backgroundColor: "Background Color",
    resetView: "Reset View",
  },
  mapTool: {
    tool: {
      splitView: "Split view",
      splitViewCount: "{{count}}-pane view",
      fullscreen: "Fullscreen",
      exitFullscreen: "Exit fullscreen",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      marker: "Point",
      multiMarker: "Multi point",
      line: "Line",
      polygon: "Polygon",
      rectangle: "Rectangle",
      text: "Text",
      modify: "Edit vertices",
      move: "Move",
      delete: "Delete",
      distance: "Distance",
      orthogonal: "Vertical",
      area: "Area",
      profile: "Profile",
      remover: "Measurement eraser",
      droneImage: "Drone image",
      areaCapture: "Area capture",
      annotationTitle: "Show issue names",
    },
    autoIssueName: "Issue {{n}}",
    issueLayerOn: {
      notice: "Issue layer turned on",
    },
    deleteConfirm: {
      cancel: "Cancel",
      subtitle: 'Delete the issue "{{name}}"?',
      irreversible: "A deleted issue cannot be restored",
    },
  },
  messages: {
    annotationCreated: "Annotation created",
    annotationUpdated: "Annotation updated",
    annotationDeleted: "Annotation deleted",
    annotationCreateFailed: "Failed to create annotation",
    annotationUpdateFailed: "Failed to update annotation",
    annotationDeleteFailed: "Failed to delete annotation",
    issueDeleted: "Issue has been deleted.",
    issueDeleteFailed: "Failed to delete issue.",
    issueDeleteFailedForUsage:
      "The selected issue is being used in other annotations.",
    selectDateToDelete: "Please select a date to delete.",
  },
  deleteModal: {
    title: "Delete Issue",
    confirmMessage: "Are you sure you want to delete this issue?",
    delete: "Delete",
  },
  layerDeleteModal: {
    title: "Delete Layer",
    delete: "Delete",
    cancel: "Cancel",
    enterEditMode: "Delete layer",
    deleteSuccess: "Layer has been deleted.",
    deleteFailed: "Failed to delete layer.",
  },
  annotationVisibilityConfirm: {
    title: "Annotations are hidden",
    subTitle:
      "To view the selected issue, annotations must be shown. Turn them on?",
    confirm: "Turn on",
    cancel: "Cancel",
  },
  issue: {
    create: "Create Issue",
    filter: "Filter",
    empty: "No issues",
    total: "Total",
    reset: "Reset",
    apply: "Apply",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    export: "Export Issue",
    exportTitle: "Select Analysis Time Series",
    exportDescription:
      "Select the desired time series and click the confirm button to compare measurements by date and track issue progression and deterioration over time.",
    exportHint: "Please fill in all required fields.",
    noData: "No available time series data.",
    linkFailed: "Failed to link issue",
    confirm: "Confirm",
    commentCount: "{{count}} Comments",
    unexportTitle: "Remove Exported Issue",
    unexportConfirm: "The issue on {{dates}} will be deleted.",
    unexportIrreversible:
      "Deleted issues cannot be restored. Grade and position edits for those dates are lost as well.",
    unexportAction: "Remove",
    applying: "Applying issue export",
    applySuccess: "Issue linked successfully",
    partialFailure: "Some items could not be processed. ({{count}})",
  },
  form: {
    type: "Annotation Type",
    name: "Name",
    fontSize: "Font Size",
    size: "Size(px)",
    color: "Color",
    opacity: "Opacity",
    position: "Position",
    lonlat: "Lon/Lat",
    xCoord: "x-coord",
    yCoord: "y-coord",
    issue: "Issue Type",
    category: "Category",
    categoryPlaceholder: "Select category",
    grade: "Grade",
    gradePlaceholder: "Select",
    memo: "Memo",
    photo: "Photo",
  },
  layer: {
    noModels: "No models available",
    orthomosaic: "Orthomosaic",
    dsm: "Digital Surface Model",
    stratum: "Stratum Layer",
    design: "Design Layer",
    line: "Line Layer",
    longitudinal: "Longitudinal Section",
    crossSection: "Cross Section",
    crossSectionList: "Saved Cross Sections",
    specificCrossSection: "Specific Cross Section",
  },
  export: {
    shootingDate: "Shooting Date",
    ground: "Ground Level",
    plan: "Design Height",
    stratum: "Stratum",
    selectDate: "Select Date",
    selectFile: "Select File",
    create: "Create",
    creating: "Creating...",
    alertMessage:
      "Only completed files can be used, and file creation will be completed within 10 minutes after request.\nEarthwork table: If no plan level is selected, the remaining volume is calculated from the difference between the selected design ground level and the current drone ground level.",
    noSection: "No section selected.",
    createStarted: "File creation started.",
    notFound: "Cross section data not found.",
    createFailed: "Failed to create file.",
    downloadTooltip:
      "Click the download button to export\ncross-section data as CSV and other file formats.",
  },
  projectInfo: {
    title: "Information",
    edit: "Edit",
    project: "Project",
    mapping: "Mapping",
  },
  issueList: {
    title: "Issues",
    total: "Total Issues",
    create: "Create",
    filter: "Filter",
    noIssues: "No issues registered",
    noFilteredIssues: "No filtered issues",
    flyTo: "Fly to issue",
    flyToAria: "Fly to issue {{name}}",
    notInCurrentTimeSeriesTitle: "Issue not in current time series",
    notInCurrentTimeSeriesBody:
      "This issue does not exist in the current time series. You can create it here with 'Export Issue' in the issue details.",
    openIssueInfo: "Open issue details",
    close: "Close",
  },
  layerFlyTo: {
    label: "Fly to drawing",
    aria: "Fly to drawing {{name}}",
    blockedFar:
      "This layer is about {{distance}} km from the site, so the view won't move. Check the file's coordinate system.",
    blockedUnresolvable:
      "The layer's extent can't be determined, so the view won't move.",
  },
  issueDetail: {
    grade: "Issue Grade",
    type: "Issue Type",
    tool: "Annotation Tool",
    created: "Created Date",
    updated: "Updated Date",
    creator: "Creator ID",
    gradeTrend: "Grade Trend",
    noDate: "No date",
    notInTimeSeries: "This issue is not in the selected standard time series.",
    linkToTimeSeries:
      "Please change the standard time series or link the issue to the standard time series.",
  },
  measurement: {
    coordinates: "Coordinates",
    coordinatesFile: "Coordinates",
    measurementFile: "Measurement",
    volumeFile: "Volume",
    line: "Line Information",
  },
  transferList: {
    timeSeriesList: "Time Series List",
    selectedTimeSeries: "Selected Time Series",
    selectAll: "Select All",
    standard: "Standard",
    export: "Export",
  },
  issueTypeModal: {
    title: "Manage Issue Types",
    close: "Close modal",
    searchPlaceholder: "Enter search term",
    addType: "Add Type",
    issueName: "Issue name",
    add: "Add",
    enterName: "Please enter issue type name.",
    typeAdded: "New issue type has been added.",
    addFailed: "Failed to add issue type.",
  },
  profile: {
    title: "Profile",
    close: "Close",
    resetView: "Reset view",
    overflowMenu: "More tools",
    copyCoordinate: "Copy coordinates",
    copied: "Copied",
    copyFailed: "Couldn't copy",
    copyHint: "Click the graph to pin a coordinate you can copy",
    fullscreen: "Fullscreen",
    exitFullscreen: "Exit fullscreen",
    themeToggleToLight: "Light theme",
    themeToggleToDark: "Dark theme",
    labelMode: {
      prefix: "Labels",
      hover: "Hover",
      on: "Pin",
      tooltipHover: "Show labels only on hover",
      tooltipOn: "Always show labels",
    },
    opacity: {
      label: "Modal opacity",
      tooltip: "Adjust modal opacity",
    },
    colorMode: {
      prefix: "Color",
      model: "Model",
      real: "Real",
      tooltipModel: "Show each model in its unique color",
      tooltipReal: "Show the 3D model's original colors",
    },
    colorModes: {
      realistic: "Realistic",
      model: "Model",
      modelByModel: "By model",
      comingSoon: "coming soon",
    },
    capture: {
      tooltip: "Capture image",
      formats: {
        png: "PNG",
        jpg: "JPG",
        jpeg: "JPEG",
        webp: "WEBP",
      },
    },
    measureTools: {
      point: "Point measure",
      polyline: "Line measure (click to add points, right-click to finish)",
      axes: "Axes measure (multiple vertical & horizontal intersection measurements)",
      rectangle: "Grid measure",
      circle: "Circle measure",
      erase: "Erase",
      eraseSelect: "Selection",
      eraseSelectHint: "Click a point, shape, or label to erase individually",
      eraseAll: "All",
      eraseAllHint: "Erase every measurement on the profile chart",
    },
    colorModePopover: {
      title: "Color mode",
      realisticHint: "Shows the captured image in its original colors.",
      modelHint: "Shows each model in a unique color. Model filter available.",
    },
    modelFilter: {
      title: "Model filter",
      modeOnly: "Only available in By-model mode.",
      empty: "No models to display.",
    },
    modelLegend: {
      ariaList: "Model color legend",
      toggleHide: "Hide cross-section",
      toggleShow: "Show cross-section",
    },
    axis: {
      distance: "Distance (m)",
      orthoHeight: "Height (m)",
      deltaHeight: "Δheight",
      deltaDistance: "Δdistance",
    },
    coordinateLabels: {
      longitude: "Longitude",
      latitude: "Latitude",
      ellipsoidHeight: "Ellipsoid height",
    },
    coordSystemWarning: {
      unsupportedEpsg:
        "This project uses an unsupported coordinate system (EPSG:{epsg}). KOREA2000 readout is unavailable.",
    },
    loading: {
      capturing: "Generating cross-section...",
      captureFailed: "Failed to load cross-section image",
    },
    empty: {
      noIntersection: "No BIM/Mesh models intersect with the cross-section.",
    },
    metrics: {
      sharpness: "Sharpness",
      accuracy: "Accuracy",
      confidence: "Confidence",
      tooltips: {
        sharpness:
          "Pixel dimensions of the cross-section image. Higher values yield sharper zoom-in detail. Unrelated to measurement accuracy; varies with display pixel density (DPR) and panel size.",
        accuracy:
          "Theoretical measurement limit derived from the project 3D model GSD. Reflects the model's intrinsic pixel resolution.",
        confidence:
          "Conservative error bound trustworthy for real measurements. Estimated as ~2× GSD per photogrammetry industry practice.",
      },
    },
    fullExport: {
      currentStation: "Current station",
      currentStationDescription: "Downloads the current station right away.",
      allStationsTitle: "Export all stations",
      allStationsDescription: "The result is saved to Export history in this panel, where you can download CSV and DXF.",
      confirmTitle: "Export all stations",
      confirmMessage: "You can download the result from Export history in this panel.",
      stationCount: "Stations",
      start: "Start export",
      started: "All-station export started.",
      tooLargeSectionLength: "The export is too large — {{axis}} {{actual}} / max {{maximum}}. Widen the Cross Interval, narrow the Line range or Width setting, or turn off some layers.",
      tooLargeSamples: "The export is too large — {{axis}} {{actual}} / max {{maximum}}. Widen the Point interval or Cross Interval, narrow the Line range or Width setting, or turn off some layers.",
      tooLargeUnknownAxis: "The export is too large — {{axis}} {{actual}} / max {{maximum}}.",
      axisSectionLength: "section length sum (m) × layer count",
      axisSamples: "total points",
      inProgress: "An all-station export for this annotation is already running. Check Export history.",
      capacityReached: "Too many all-station exports are running right now. Try again shortly.",
      startFailed: "Could not start the all-station export.",
      fileSuffix: "all",
    },
    exportHistory: {
      title: "Export history",
      buttonRunning: "Export history · {{percent}}%",
      buttonCompleted: "Export history · Done",
      buttonFailed: "Export history · Failed",
      empty: "You can download all-station export results here.",
      loadFailed: "Could not load the export history.",
      summary: "Stations {{stations}} · Point interval {{step}} m · Layers {{series}}",
      sectionSettings: "Range {{first}}–{{last}} · Starting survey point {{start}} m · Cross interval {{interval}} m · L/R {{left}}/{{right}} m",
      completed: "Done",
      failed: "Failed",
      detailsLabel: "{{time}} export ({{status}}) details",
      progressLabel: "All-station export progress",
      downloadCsv: "Download CSV of {{time}} export",
      downloadDxf: "Download DXF of {{time}} export",
      delete: "Delete",
      deleteLabel: "Delete {{time}} export",
      notFound: "This export no longer exists.",
      downloadFailed: "Could not create the file.",
      deleteFailed: "Could not delete the export.",
    },
  },
  report: {
    title: "Report",
    create: "Create Report",
    export: "Export Report",
    formTitle: "Title",
    titlePlaceholder: "Enter report title",
    author: "Author",
    authorPlaceholder: "Enter author name",
    organization: "Organization",
    job: "Job",
    email: "Email",
    phone: "Phone",
  },
  vector: {
    title: "Vector",
    totalCount: "Total {{count}}",
    showOnMap: "Show on map",
    create: {
      sectionTitle: "Create vector",
      open: "Create with coordinates",
      name: "Name",
      namePlaceholder: "Vector name",
      modeLngLat: "Lat/Lng",
      modeProjectCrs: "X/Y coordinates",
      lng: "Longitude",
      lat: "Latitude",
      x: "X",
      y: "Y",
      elHeight: "Height (m)",
      color: "Color",
      radius: "Radius (m)",
      shape: "Shape",
      shape_line: "Line",
      shape_cylinder: "Cylinder",
      shape_square: "Square prism",
      side: "Side (m)",
      shapeLineNoSize: "No size for line",
      radiusValueHint: "Enter value",
      commentPlaceholder: "Add a memo (optional)",
      addPoint: "Add point",
      submit: "Create",
      epsgUnavailable: "Project CRS is unavailable.",
      createFailed: "Failed to create the vector.",
    },
    list: {
      sectionTitle: "Vector list",
      empty: "No vectors yet.",
      emptyDesc: "Create one with coordinates above.",
      loading: "Loading vectors…",
      loadFailed: "Failed to load vectors.",
      retry: "Retry",
      radius: "Radius (m)",
      line: "Line",
      radiusValue: "{{symbol}} {{value}}m",
      pointCount: "{{count}} points",
      delete: "Delete",
      deletePoints: "Delete points",
      deleteConfirmTitle: "Delete vector",
      deleteConfirmMessage: "Delete the vector '{{name}}'?",
      deleteIrreversible: "This cannot be undone.",
      deleteFailed: "Failed to delete the vector.",
      updateFailed: "Failed to update the vector.",
      infoSection: "Info",
      coordinates: "Coordinates",
      perpendicular: "Cross-section",
      save: "Save",
      reset: "Reset",
    },
    perpendicular: {
      title: "Cross-section",
      position: "Cut position (from start, m)",
      totalLength: "Total length {{length}}m",
      meterUnit: "m",
      positionRange: "Cut position must be between 0 and the total length.",
      length: "Cut line length (m)",
      confirm: "Confirm",
      lengthRange: "Length must be greater than 0 and at most 1000.",
      invalid:
        "Cannot compute the cut line.\nA vertical or single-point vector cannot form a cross-section.",
    },
    selection: {
      selectDelete: "Delete",
      selectAll: "Select all",
      deselectAll: "Deselect all",
      confirm: "Confirm",
      confirmMessage: "Delete {{count}} vectors?",
      minPointsHint: "At least {{count}} points must remain",
    },
    errors: {
      nameLength: "Name must be {{nameMin}}-{{nameMax}} characters.",
      commentLength: "Memo must be {{commentMax}} characters or fewer.",
      minPoints: "At least {{minPoints}} points are required.",
      maxPoints: "Up to {{maxPoints}} points are allowed.",
      notNumber: "Enter a number.",
      lngRange: "Longitude must be between {{lngMin}} and {{lngMax}}.",
      latRange: "Latitude must be between {{latMin}} and {{latMax}}.",
      radiusRange:
        "Radius must be between {{sizeExclusiveMin}} and {{maxRadius}}.",
      sideRange: "Side must be between {{sizeExclusiveMin}} and {{maxSide}}.",
    },
  },
  geoLog: {
    title: "Photos·Videos",
    totalCount: "Total {{count}}",
    showOnMap: "Show on map",
    noFilesHint: "Files appear once the map is loaded.",
    emptyFiles: "No photos or videos registered.",
    noPosition: "No location",
    groupCount: "{{count}}",
    locationGroup: {
      noPositionDesc: "These photos aren't shown on the map yet.",
    },
    uncategorized: "Uncategorized",
    noCaptureDate: "No date",
    uploaderMe: "Me",
    groupEdit: {
      title: "Edit group",
      label: "Edit group",
      titleField: "Edit {{field}} for all",
      desc: "Apply the same {{field}} to all {{count}} photos in this group.",
    },
    view: {
      captureDate: "Capture date",
      category: "Topic",
      uploader: "Uploader",
      locationName: "Location",
    },
    sort: {
      latest: "Newest",
      oldest: "Oldest",
    },
    position: {
      modalTitle: "Location",
      placeCard: "Set location",
      placeHint: "Place on map",
      clearCard: "Clear location",
      clearHint: "Remove pin",
      attachCard: "Add to existing",
      attachHint: "Merge into a spot",
      unnamedLocation: "Unnamed location",
      existingCount: "{{count}} here",
      addAction: "Add here",
      selectTargetHint:
        "You can gather photos at a spot that already has a location.\nFirst choose the existing location to add to.",
      placeStepHint:
        "Click an empty spot for a new location, or an existing marker to add to it.\nSelect the photos to place.",
      clearStepHint:
        "You can remove the location set on photos.\nSelect the photos to clear.",
      attachStepHint:
        "You can gather the selected photos at this location.\nSelect the photos to add here.",
      noLocation: "No locations yet",
      back: "Back",
      selectAll: "Select all",
      deselectAll: "Deselect all",
      placeEmpty: "No photos without a location",
      clearEmpty: "No photos with a location",
    },
    toolbar: {
      upload: "Upload",
      place: "Location",
      delete: "Delete",
      download: "Download",
    },
    upload: {
      modalTitle: "Upload",
      fileCard: "Upload files",
      fileCardHint: "Pick files from device",
      folderCard: "Upload folder",
      folderCardHint: "Pick a whole folder",
      mapCard: "Upload onto map",
      mapCardHint: "Drag and drop onto map",
      dropZoneHint: "Or drag files·folders here",
      dropActive: "Drop here to upload",
      sizeLimit: "Up to {{limit}} per upload",
      uploading: "Uploading...",
      uploadingShort: "Uploading",
      queued: "Waiting",
      cancel: "Cancel",
    },
    selection: {
      count: "{{count}} selected",
      selectGroup: "Select group",
      confirm: "Place on map",
      deleteTitle: "Delete files",
      deleteIrreversible: "Deleted files cannot be recovered.",
      delete: "Delete",
      cancel: "Cancel",
      clear: "Clear location",
      deleteConfirm: "Delete the {{count}} selected files?",
      download: "Download",
      selectDelete: "Delete selected",
      selectDownload: "Download selected",
      downloadTitle: "Download files",
      downloadConfirm: "Download the {{count}} selected files?",
    },
    edit: {
      date: "Date",
      category: "Topic",
      categoryPlaceholder: "Select or type a topic",
      locationName: "Location name",
      locationNamePlaceholder: "e.g. Pier 1, East entrance",
      save: "Save",
      reset: "Revert",
      cancel: "Cancel",
    },
    cell: {
      moveToPosition: "Go to location",
      setPosition: "Set location",
      detail: "Details",
      moveToPositionAria: "Go to location of {{name}}",
      setPositionAria: "Set location of {{name}}",
      detailAria: "View details of {{name}}",
    },
    detail: {
      uploader: "Uploader",
      fileSize: "Size",
      locationJoinPlaceholder: "Select an existing location",
      locationJoinHint:
        "Saves to the existing location. To create a new one, use the 'Set location' button above.",
      locationMoveHint: "Only this photo moves to the selected location.",
      locationAssignHint:
        "Saves as a new location name at the current position.",
      locationRenameGuide:
        "Location name belongs to the location. Rename it from the map preview card or the location-grouped view in the sidebar — it applies to every photo at that location.",
      captureDate: "Capture date",
      category: "Topic",
      locationName: "Location name",
      viewPosition: "View location",
      viewPositionShort: "View",
      movePosition: "Move",
      movePositionAria: "Move location",
      expand: "Expand",
      collapse: "Collapse",
    },
    pano: {
      view360: "360°",
      viewFlat: "2D",
      resetView: "Reset view",
      play: "Play",
      pause: "Pause",
      mute: "Mute",
      unmute: "Unmute",
      seek: "Seek",
    },
    roadview: {
      label: "Walkthrough",
      enter: "Walkthrough",
      exit: "Exit walkthrough",
      previous: "Previous point",
      next: "Next point",
      moveToPoint: "Move to point {{ordinal}}",
      progress: "{{current}} / {{total}}",
      miniMap: "Session mini map",
      departedPoint: "Previous point",
      currentPoint: "Current point",
      departedDirection: "Direction of previous point",
      relation: {
        previous: "previous point",
        next: "next point",
        spatial: "nearby point",
      },
      compass: {
        n: "N",
        ne: "NE",
        e: "E",
        se: "SE",
        s: "S",
        sw: "SW",
        w: "W",
        nw: "NW",
      },
      dualFisheye:
        "This is an unstitched original and cannot be opened in 360°",
    },
    card: {
      close: "Close",
      previewClose: "Close preview",
      loadFailed: "Failed to load",
      unplayableVideo: "This browser can't play this video format. Download it to view.",
      download: "Download",
      deleteFile: "Delete file",
      deleteFileConfirm: "Delete this file?",
      deleteScopePrompt: "Delete which?",
      scopePrompt: {
        place: "Edit position for?",
        clear: "Clear position for?",
      },
      clearAllConfirm:
        "Clear position of all {{count}} photos at this location?",
      scopeThis: "This only",
      scopeAll: "All {{count}}",
      positionSetting: "Location",
      editPosition: "Edit location",
      editPositionShort: "Edit",
      editLocationName: "Edit location name",
      clearPosition: "Clear location",
      clearPositionShort: "Clear",
      clearPositionConfirm: "Clear this location?",
      release: "Clear",
      delete: "Delete",
      cancel: "Cancel",
      detail: "Details",
      prevFile: "Previous file",
      nextFile: "Next file",
      addHere: "Add photo here",
      addPhoto: "Add photos",
      addPhotoShort: "Add",
      addHereSelect: "Select files to add here ({{count}})",
    },
    marker: {
      placeHint:
        "Click the map to set a location · click an existing marker to add to it",
      mapUploadHint: "Drag files·folders onto the map where you want them",
      rightClickCancel: "Right-click to cancel",
      single: "{{name}} marker",
      cluster: "{{count}} photos·videos marker",
      addToHere: "Add {{name}} here",
    },
    notice: {
      onlyGeoLog: "Only image and video files can be uploaded",
      emptyFile: "Empty files cannot be uploaded",
      excludedNonGeoLog: "{{count}} non-geoLog files were excluded",
      dropOnModel: "Please drop onto the model",
      placeFailed: "Failed to set location",
      uploadFailed: "Upload failed",
      alreadyUploading: "Skipped {{count}} file(s) already uploading",
      uploadTooLarge: "Exceeds the {{limit}} limit per upload",
      quotaExceeded: "Cannot upload: total size exceeds {{limit}}",
      usageUnknown: "Cannot upload: storage usage is unavailable",
      partialExcluded:
        "Uploading without {{count}} excluded files ({{detail}})",
      allExcluded: "No files available to upload ({{detail}})",
      excludeReason: {
        empty: "0 bytes",
        nonMedia: "Unsupported format",
        invalidName: "Invalid file name",
        tooLarge: "Too large",
      },
      deleteFailed: "Failed to delete file",
      listFailed: "Failed to load the list",
      clearFailed: "Failed to clear location",
      addFailed: "Failed to add photo",
      updateMetaFailed: "Failed to update info",
      updateMetaSaved: "Saved",
      downloadFailed: "Download failed",
      loadFailed: "Failed to load the list",
      retry: "Retry",
    },
    scope: {
      drawArea: "Area filter",
      addArea: "Add area",
      hint: "Draw an area on the map or click a marker to see only the photos and videos in it. Click an area on the map again to remove it from the selected areas.",
      help: "About area filter",
      areas: "{{count}} areas",
      areaLabel: "Area {{n}}",
      count: "{{count}} / {{total}}",
      countAria: "Showing {{count}} of {{total}}",
      drawing: "Drawing an area…",
      drawCancel: "Cancel drawing",
      drawingHint:
        "Drag on the map to draw an area. Press ESC or right-click to cancel.",
      dragOnGround: "Keep all four corners on the ground",
      flyTo: "Go to areas",
      clear: "Clear filter",
      empty: "No photos or videos in the selected areas",
      emptyHint: "Draw another area or go back to all",
      emptyNoPositioned:
        "Nothing has a location yet. Set locations in the group below",
      showAll: "Show all",
      unpositionedTag: "Not tied to scope",
      unpositionedDesc: "Once located, items appear when inside the scope",
      placedOutside: "Placed outside the areas, so it is hidden from the list",
      dropWhileDrawing: "You can't upload while drawing an area",
    },
    usage: {
      title: "Storage used",
    },
  },
  equipment: {
    menu: "Equipment",
    title: "Equipment",
    totalCount: "Total {{count}}",
    showOnMap: "Show on map",
    listLabel: "Equipment",
    add: "Add equipment",
    addFolder: "Add folder",
    captureView: "Capture",
    captureFormat: "Image format",
    loading: "Loading equipment",
    loadFailedTitle: "Couldn't load equipment",
    loadFailedDesc: "Please try again in a moment.",
    refreshFailed: "Couldn't refresh the equipment list",
    dock: {
      label: "Equipment",
      close: "Close equipment list",
      collapse: "Collapse",
      all: "All",
      categories: "Equipment categories",
      types: "Equipment types",
      prev: "Previous equipment",
      next: "Next equipment",
      loadFailed: "Couldn't load equipment types",
      refreshFailed: "Couldn't refresh equipment types",
      empty: "No equipment available to add",
    },
    catalog: {
      category: {
        lifting: "Lifting",
        earthwork: "Earthwork",
        temporary: "Temporary",
        material: "Material",
        labor: "Labor",
      },
      type: {
        towerCrane: "Tower crane",
        mobileCrane: "Mobile crane",
        aerialPlatform: "Aerial platform",
        excavator: "Excavator",
        dumpTruck: "Dump truck",
        mixerTruck: "Mixer truck",
        loader: "Loader",
        roller: "Roller",
        concretePump: "Concrete pump",
        drillRig: "Drill rig",
        forklift: "Forklift",
      },
    },
    intro: {
      title: "Try moving your equipment ahead of time",
      riskTag: "Risk",
      speedTag: "{{speed}} km/h",
      realSizeTitle: "Actual size",
      realSizeDesc: "Placed as true-size models",
      reachTitle: "Check working radius",
      reachDesc: "See overlapping radii in advance",
      simulationTitle: "Simulation",
      simulationDesc: "Move along any route and speed",
    },
    list: {
      risk: "Risk {{count}}",
      toggleVisibility: "Show {{name}} on map",
      expand: "Expand {{name}}",
      rowMenu: "More for {{name}}",
      visibilityFailed:
        "Couldn't change map visibility. Please try again shortly",
      moveTo: "Go to location",
      rename: "Rename",
      delete: "Delete",
      duplicate: "Duplicate",
      duplicateSuffix: " (copy)",
      duplicateFailed: "Couldn't duplicate. Please try again shortly",
      duplicateFolderFailed: "Couldn't duplicate the folder. Please try again shortly.",
      deleteFolderFailed: "Couldn't delete the folder. Please try again shortly.",
      captureFailed: "Couldn't capture the screen. Please try again shortly.",
      renameInput: "Name of {{name}}",
      renameConfirm: "Save name of {{name}}",
      renameCancel: "Cancel renaming {{name}}",
      renameFailed: "Couldn't rename. Please try again shortly",
      deleteFailed: "Couldn't delete the equipment. Please try again shortly",
      deleteTitle: "Delete Equipment",
      deleteMessage: "Delete '{{name}}'?",
      deleteSubMessage: "Deleted equipment cannot be restored.",
      deleteCancel: "Cancel",
      deleteConfirm: "Delete",
    },
    detail: {
      tabs: "{{name}} details",
      tab: {
        spec: "Spec",
        position: "Position & heading",
        route: "Route",
      },
      cancel: "Cancel",
      apply: "Apply",
      position: "Position",
      moveOnMap: "Move on map",
      longitude: "Longitude",
      latitude: "Latitude",
      altitude: "Height",
      heading: "Facing direction",
      headingInput: "Facing direction (degrees)",
      moving: "Moving",
      origin: "Original position",
      specFailed: "Couldn't save the spec. Please try again shortly",
      headingFailed: "Couldn't save the direction. Please try again shortly",
      moveFailed: "Couldn't move it. Please try again shortly",
    },
    route: {
      emptyTitle: "No route yet",
      emptyBody: "Click points on the map to draw a route.",
      draw: "Draw route",
      drawing: "Drawing route",
      editing: "Editing route",
      cancel: "Cancel",
      done: "Done",
      distance: "Distance",
      points: "Points",
      pointsLimit: "A route can have up to {{max}} points",
      duration: "Est. time",
      meters: "{{distance}} m",
      play: "Play route",
      pause: "Pause",
      repeat: "Repeat playback",
      repeatShort: "Repeat",
      position: "Playback position",
      positionValue: "{{elapsed}} / {{total}}",
      speed: "Speed",
      speedSlider: "Playback speed",
      simulation: "Route simulation",
      speedUnit: "km/h",
      edit: "Edit",
      delete: "Delete",
      locked: "Pause route playback to make changes.",
      deleteTitle: "Delete route",
      deleteMessage: "Delete the route of '{{name}}'?",
      deleteSubMessage: "A deleted route can't be restored.",
      deleteCancel: "Cancel",
      deleteConfirm: "Delete",
      saveFailed: "Couldn't save the route. Please try again shortly",
      deleteFailed: "Couldn't delete the route. Please try again shortly",
    },
    placement: {
      createFailed: "Couldn't place the equipment. Please try again shortly",
      name: "Name",
      spec: "Base spec",
      custom: "Custom",
      dimensions: "Dimensions",
      length: "Length",
      width: "Width",
      height: "Height",
      reach: "Working radius",
      unit: "m",
      radiusColor: "Radius color",
      radiusColorDisabled: "Available when a working radius is set",
      close: "Close",
      place: "Place",
      error: {
        nameRequired: "Enter a name",
        nameTooLong: "Names can be up to {{max}} characters",
        dimensionRange: "Enter a value above 0 and up to {{max}}",
        reachRange: "Enter 0–{{max}} or leave it empty",
      },
    },
    radiusColor: {
      peach: "Peach",
      lemon: "Lemon",
      mint: "Mint",
      lavender: "Lavender",
      pink: "Pink",
    },
  },
} as const;

export default timeSeries;
